module.exports = __webpack_public_path__ + "62547ef7a31154e4d0676fc87624532b.svg";